import React, { useContext, useEffect, useState } from 'react';
import { DataTableWrapper } from './DataTableWrapper';
import { PageHeader } from './PageHeader';
import { IPageState } from '../../pages/Devices/DeviceImport';
import { strings } from '../../services/Localization';
import { getAppBase } from '../../utils/consts';
import AppContext from '../../context/AppContext';
import { FileDropZone } from '../../pages/Devices/FileUploadZone';
import { toast } from "./../../utils/Toaster";
import { useNavigate } from 'react-router';
import ProgressBar from 'react-bootstrap/ProgressBar';

// Import your new upload function
import { GenericDassUpload } from '../../services/BasicDassQueries';

type Props = {
  uploadUrl: string;
};

export const Import: React.FC<Props> = ({ uploadUrl }) => {
  const appContextObj = useContext(AppContext);
  const navigate = useNavigate();

  const PageStateInit: IPageState = {
    user: {},
    pageTitle: '',
    showDeviceList: false,
    allSelected: true,
    limit: 50,
    page: 0,
    totalPage: 0,
    breadCrumbArr: [
      { label: strings.NAV_DEVICES_ITEM, url: `${getAppBase()}/devices` },
      { label: strings.DEVICES_DATA_IMPORT, url: '' }
    ],
    nameIndex: 0,
  };

  const [pageState, setPageState] = useState<IPageState>(PageStateInit);
  const [progress, setProgress] = useState<number>(0);
  const [uploading, setUploading] = useState<boolean>(false);

  useEffect(() => {
    setPageState(prevState => ({
      ...prevState,
      user: appContextObj?.user
    }));
  }, [appContextObj]);

  const uploadFile = async (file: File) => {
    const allowedFormats = ['jsonl', 'gz'];
    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    if (!allowedFormats.includes(fileExtension)) {
      toast.error('Only .jsonl and .gz file format is allowed.');
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setUploading(true);
      setProgress(0);

      const response = await GenericDassUpload(uploadUrl, {
        method: 'POST',
        data: formData,
        onUploadProgress: (event: ProgressEvent) => {
          if (event.lengthComputable) {
            const percent = Math.round((event.loaded * 100) / event.total);
            setProgress(percent);
          }
        }
      });

      if (response.status > 299) {
        throw { status: response.status, message: response.data };
      }

      toast.success(`${strings.IMPORT_JOB_SUCCESS_MESSAGE} - ${response.data}`);
      navigate(`${getAppBase()}/import-jobs?search_jobUuid=${response.data}`);

    } catch (error: any) {
      console.error('Upload failed:', error);
      toast.error(error?.message || strings.ERROR_PROCESSING_FILE);
    } finally {
      setUploading(false);
      setProgress(0);
    }
  };

  return (
    <DataTableWrapper>
      <PageHeader
        name="import-devices-data"
        breadCrumbArr={pageState.breadCrumbArr}
        pageButtons={[]}
      />
      <div className="mx-0 d-lg-flex border-bottom border-2 mb-2">
        <div className="d-flex w-100 align-items-center justify-content-center p-2">
          <FileDropZone uploadFile={uploadFile} uploadMessage={strings.UPLOAD_JSONL_MSG} />
        </div>
      </div>
      {uploading && (
        <div className="mx-4 my-3">
          <ProgressBar now={progress} label={`${progress}%`} animated striped />
        </div>
      )}
    </DataTableWrapper>
  );
};
